import React, { useState, useRef, useEffect } from "react";
import * as Mui from "@mui/material";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { EmployeeBankDetailsHeader } from "pages/PayRoll/PayRollHeaders";
import { tableHeaderSx } from "services/constants";
import { tableRowSx } from "services/constants";
import { InfoMessage } from "components/CustomComponents/CustomButton";

export const EmployeeBankTable = ({
  salaryDetails,
  listViewPage,
  setListViewPage,
  salarySatementState,
  loader,
}) => {
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const handleChangePage = (event, newPage) => {
    setListViewPage(newPage);
  };
  const containerRef = useRef(null);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setListViewPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [listViewPage]);

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{
            mt: 2,
            width: "100%",
            maxHeight: 720,
            ml: 2,
            mr: 2,
          }}
        >
          <Mui.Table className="border">
            <Mui.TableHead sx={tableHeaderSx}>
              <Mui.TableRow sx={tableRowSx}>
                {EmployeeBankDetailsHeader.map((header) => (
                  <Mui.TableCell
                    sx={{ color: themes.blackColor, fontWeight: "bold" }}
                  >
                    {header.name}
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {salaryDetails?.length === 0 && !loader ? (
                <InfoMessage dataLength={salarySatementState} />
              ) : (
                salaryDetails
                  ?.slice(
                    listViewPage * rowsPerPage,
                    listViewPage * rowsPerPage + rowsPerPage
                  )
                  .map((salary) => (
                    <Mui.TableRow sx={tableRowSx}>
                      {EmployeeBankDetailsHeader.map((header) => (
                        <Mui.TableCell sx={{ color: themes.blackColor }}>
                          {header.key === "user_name" ? (
                            <Mui.Stack direction="Row">
                              <Mui.Avatar
                                sx={{
                                  width: 23,
                                  height: 23,
                                }}
                                alt={salary?.user_name?.charAt(0).toUpperCase()}
                                src={salary?.image_url ?? optionalAvathar}
                              />
                              &nbsp;
                              {salary?.user_name}
                            </Mui.Stack>
                          ) : salary[header.key] || salary[header.key] === 0 ? (
                            salary[header.key]
                          ) : (
                            "N/A"
                          )}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>

      {salaryDetails?.length > 25 && (
        <Mui.TablePagination
          className="custom-pagination"
          component="div"
          rowsPerPageOptions={[25, 50, 75, 100]}
          count={salaryDetails?.length}
          rowsPerPage={rowsPerPage}
          page={listViewPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </React.Fragment>
  );
};
